import { render, staticRenderFns } from "./CommercialPrintChanges.vue?vue&type=template&id=99d56290&scoped=true"
import script from "./CommercialPrintChanges.vue?vue&type=script&lang=js"
export * from "./CommercialPrintChanges.vue?vue&type=script&lang=js"
import style0 from "./CommercialPrintChanges.vue?vue&type=style&index=0&id=99d56290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d56290",
  null
  
)

export default component.exports